import { component } from 'knockout-decorators'

import { EventState } from '~/store/event'
import type { TicketState } from '~/store/ticket'

import codeIcon from '~/images/code.svg?raw'
import couponIcon from '~/images/coupon.svg?raw'
import source from './counted-ticket.html?raw'

@component('counted-ticket', source)
export class CountedTicket {
  private eventState: EventState = EventState.get()
  private icons = {
    codeIcon,
    couponIcon,
  }

  private ticketState: TicketState

  constructor(private params: { offerId: string }) {
    this.ticketState = this.eventState.offerSates[this.params.offerId]
  }
}
